import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import URL from '../../../../constants/url';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import ToastPopup from '../../../../components/comm/ToastPopup';
import { formatDate, getDpSnsSignin, setDpAuthResetPhonenumberCid } from '../../../../assets/js/comm';
import MSG from '../../../../constants/message';

const NiceRedirectPage = () => {
  const navigate = useNavigate();
  const [sp] = useSearchParams();

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [sec, setSec] = useState(3);

  const [redirecting, setRedirecting] = useState(false);
  const [baseMsg, setBaseMsg] = useState('');

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  const tx = useMemo(() => sp.get('tx') || '', [sp]);

  const [ signUsrInfo, setSignUsrInfo ] = useState({});

  const clearTimers = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    intervalRef.current = null;
    timeoutRef.current = null;
  };

  // 공통 카운트다운 시작 함수
  const startRedirect = (message, seconds = 3, url = URL.LANDING) => {
    clearTimers();
    setBaseMsg(message);
    setSec(seconds);
    setToast(true);
    setRedirecting(true);

    intervalRef.current = setInterval(() => {
      setSec((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    timeoutRef.current = setTimeout(() => {
      navigate(URL.LANDING, { replace: true });
    }, seconds * 1000);
  };

  // 카운트다운 문구 갱신
  useEffect(() => {
    if (redirecting) {
      setToastMessage(`${baseMsg} ${sec}초 후 \n로그인 화면으로 이동합니다.`);
    }
  }, [redirecting, baseMsg, sec]);

  // 마운트/언마운트 타이머 정리
  useEffect(() => {
    return () => clearTimers();
  }, []);

  // 플로우 시작
  const isFirstRender = useRef(true);
  useEffect(() => {
    let cancelled = false;

    const run = async () => {

      if (!isFirstRender.current) return;
      isFirstRender.current = false;

      if (!tx) { startRedirect('올바른 접근이 아닙니다.'); return; }

      const provider = sp.get('provider');

      if (!provider) { startRedirect('올바른 접근이 아닙니다.'); return; }

      const emailAdres = sp.get('emailAdres') ? sp.get('emailAdres') : '';

      const moveToMenu = sp.get('moveToMenu') ? sp.get('moveToMenu') : '';

      if (provider === 'idpw') {
        try {
          // 1) NICE 결과
          const res1 = await getAuthResult(tx);
          // if (cancelled) return;

          if (!res1?.data || res1.data.resultCode !== CODE.RCV_SUCCESS) {
            startRedirect(res1?.data?.resultMessage + '(인증 결과 처리 실패)');
            return;
          }

          const niceResult = res1.data.result?.result;
          const encptCidVal = niceResult?.encptCidVal;
          if (!encptCidVal) {
            startRedirect('인증 결과에 CI 값이 없습니다.');
            return;
          }

          // 2) 가입 여부 확인 에프터케어 디비
          const res2 = await retrievePatntInfoByCi(encptCidVal);
          // if (cancelled) return;

          if (!res2?.data || res2.data.resultCode !== CODE.RCV_SUCCESS) {
            startRedirect(res2?.data?.resultMessage + '(인증 결과 처리 실패)');
            return;
          }

          const { isSignUp , userInfo } = res2.data.result || {};
          if (isSignUp === 'Y' && userInfo?.usrId !== undefined && userInfo?.usrId !== "" && userInfo?.usrId !== null ) {
              if( moveToMenu === "findId" ) { // 아이디 찾기
                  navigate(URL.FINDID,
                      { state: {...niceResult, provider : provider, emailAdres: emailAdres
                          , usrId: userInfo?.usrId
                          , signupDt: formatDate(userInfo?.signupDt?.replace(/[ .:-]/g,'').substring(0, 8), 2)
                      }
                  });
              } else if( moveToMenu === "findPw" ) { // 비밀번호 찾기
                  navigate(URL.FINDPASSWORD,
                      { state: {...niceResult, provider : provider, emailAdres: emailAdres
                          , usrId: userInfo?.usrId
                          , usrUid: userInfo?.usrUid
                      }
                  });
              } else {
                  // 기본
                  startRedirect('이미 가입되어 있는 사용자입니다.');
              }
          } else {
            navigate(URL.AGREECONDITIONS, { state: {...niceResult, provider : provider, emailAdres: emailAdres} });
          }
        } catch (e) {
          console.error(e);
          if (!cancelled) startRedirect('인증 결과 호출 실패');
        }
      }else if (provider === 'phone') {
        const res1 = await getAuthResult(tx);

        if (!res1?.data || res1.data.resultCode !== CODE.RCV_SUCCESS) {
          startRedirect(res1?.data?.resultMessage + '(인증 결과 처리 실패)', 3, URL.MYINFO_WRITE);
          return;
        }

        const niceResult = res1.data.result?.result;
        const encptCidVal = niceResult?.encptCidVal;
        const mblNo = niceResult?.mblNo;
        if (!encptCidVal) {
          startRedirect('인증 결과에 CI 값이 없습니다.', 3, URL.MYINFO_WRITE);
          return;
        }

        const dbEncptCidVal = await getDbEncptCidVal();

        if(encptCidVal !== dbEncptCidVal) {
          startRedirect('가입정보가 일치하지 않습니다.', 3, URL.MYINFO_WRITE);
          return;
        }
        //디팜 휴대폰 번호 변경
        const response = await setDpAuthResetPhonenumberCid({
          cid : encptCidVal,
          phonenumber : mblNo
        })

        if(response) {
          chagneMblNo(mblNo);
        } else {
          startRedirect('휴대전화번호 변경에 실패 했습니다.', 3, URL.MYINFO_WRITE);
        }
      } else {
        // if(provider === 'kakao') {
          try {
            // 1) NICE 결과
            const res1 = await getAuthResult(tx);
            // if (cancelled) return;

            if (!res1?.data || res1.data.resultCode !== CODE.RCV_SUCCESS) {
              startRedirect(res1?.data?.resultMessage + '(인증 결과 처리 실패)');
              return;
            }

            const niceResult = res1.data.result?.result;
            const encptCidVal = niceResult?.encptCidVal;
            if (!encptCidVal) {
              startRedirect('인증 결과에 CI 값이 없습니다.');
              return;
            }

            // 2) 가입 여부 확인 에프터케어 디비
            const res2 = await retrievePatntInfoByCi(encptCidVal);
            // if (cancelled) return;

            if (!res2?.data || res2.data.resultCode !== CODE.RCV_SUCCESS) {
              startRedirect(res2?.data?.resultMessage + '(인증 결과 처리 실패)');
              return;
            }

            const { isSignUp , userInfo } = res2.data.result || {};

            // 3) 저장했던 sns 인증 토큰 받아옴
            const r1 = sp.get('param_r1');
            const emailAdres = sp.get('emailAdres');

            if(!r1) {
              startRedirect('올바른 접근이 아닙니다.');
              return;
            }

            const res3 = await getSnsToken(r1);

            if (!res3?.data || res3.data.resultCode !== CODE.RCV_SUCCESS) {
              startRedirect(res3?.data?.resultMessage + '(sns 토큰 호출 실패)');
              return;
            }

            const { accessToken, sns } = res3.data.result;

            if (isSignUp === 'Y') { //이미 다른 경로로 가입한 환자임
              const snsSignObj = {
                sns : sns,
                [(['naver', 'kakao'].includes(sns) ? 'accessToken' : 'idToken')]: accessToken,
                displayName: niceResult.usrNm,
                phoneNumber: niceResult.mblNo,
                email: emailAdres,
                birth: niceResult.brthdy,
                gender: niceResult.gendr,
                staff: false,
                // pushToken: "string", //앱에서만
                cid: encptCidVal
              }

              const signRes = await getDpSnsSignin(snsSignObj);

              if (signRes?.accessToken !== undefined && signRes?.accessToken !== "") {
                  const jToken = signRes?.accessToken;

                  sessionStorage.setItem('loginUser', JSON.stringify(userInfo));
                  localStorage.setItem('jToken', jToken);

                  afctrSignup(signRes.accessToken, signRes.refreshToken, sns);

              } else {
                  alert(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
              }

            } else {
              navigate(URL.AGREECONDITIONS, { state: {...niceResult, provider : provider, accessToken : accessToken, emailAdres: emailAdres} });
            }
          } catch (e) {
            console.error(e);
            if (!cancelled) startRedirect('인증 결과 호출 실패');
          }
        }
      // }

    };

    run();

    return () => {
      cancelled = true;
    };
  }, [tx, sp, navigate]);



  const getAuthResult = (tx) => {

    const url = `/nice/auth/result?tx=${encodeURIComponent(tx)}`;

    return axiosApi.post(url);
  }

  const retrievePatntInfoByCi = (encptCidVal) => {

    const url = `/signup/retrievePatntInfoByCi`;

    return axiosApi.post(url,{encptCidVal:encptCidVal},{});
  }

  const getSnsToken = (r1) => {
    const url = `/nice/auth/sns/token/${r1}`;
    return axiosApi.get(url);
  }

  const afctrSignup = async (accessToken, refreshToken, provider) => {
    const usrSeCd = provider === 'naver' ? "12" : provider === 'kakao' ? "13" :
                        provider === 'google' ? "14" : provider === 'apple' ? "15" : "";


    if (accessToken !== undefined && accessToken !== "") {

        const jToken = accessToken;
        const requestLoginUrl = "/signup/saveUser"

        const requestOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            }
        }

        const signupReq = {
            crtfcTknVal: refreshToken, usrSeCd : usrSeCd
        }

        // 애프터케어 서버 저장로직 완료 후 .. =>  MEMBERSHIP_COMPLETE  넘겨준다.
        await axiosApi.post(requestLoginUrl, signupReq, requestOptions)
            .then((res) => {
                //onsole.log( "=============> aftcrUser : ", res );
                if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                    const aftcrUser = res.data.result.aftcrUser;

                    sessionStorage.setItem('loginUser', JSON.stringify(aftcrUser));
                    localStorage.setItem('jToken', jToken);
                    if( aftcrUser.usrHsptlMap.length > 0 ) {
                        // 정상케이스
                        navigate(URL.HOME_CARE_MAIN);
                    } else {
                        // 해당부분은 맵핑된 병원이 없을 경우, 대표병원이 없을 경우, 병원연결 페이지가 뜨도록 조정해야함.
                        navigate(URL.HOSPITAL_LINK);
                    }
                } else {
                  startRedirect(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
                }
            })
            .catch((err) => {
                console.log( " ================> RCV_ERROR_SERVER ", err);
            })
    } else {
        alert(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
    }
  }

  const chagneMblNo = useCallback(async (mblNo) => {

      const url = `/setting/phone/change`;

      const jToken = localStorage.getItem('jToken');

      const reqOptions = {
          headers: {
              Authorization: `Bearer ${jToken}`,
          }
      }

      await axiosApi.post(url, {mblNo : mblNo}, reqOptions)
      .then((res) => {
          if (res.data.resultCode === CODE.RCV_SUCCESS) {
            const aftcrUser = res.data.result.userInfo;
            sessionStorage.setItem("loginUser", JSON.stringify(aftcrUser));
            navigate(URL.MYINFO_WRITE, { state: {cameFromNice: true, successYn : 'Y' , successMsg: "휴대전화번호 변경이 완료되었습니다."} });
          } else {
            startRedirect('휴대전화번호 변경에 실패 했습니다.', 3, URL.MYINFO_WRITE);
          }
      })
      .catch(err => {
          console.error("휴대폰 번호 저장 실패  : ", err);
      })
  }, []);

  const getDbEncptCidVal = useCallback(async() => {
    const url = `/setting/getDbEncptCidVal`;

    const jToken = localStorage.getItem('jToken');

    const reqOptions = {
        headers: {
            Authorization: `Bearer ${jToken}`,
        }
    }

    let dbEncptCidVal = "";

    try {
      const res = await axiosApi.post(url, {}, reqOptions);

      dbEncptCidVal = res.data.result.dbEncptCidVal ? res.data.result.dbEncptCidVal : "";

      return dbEncptCidVal;
    } catch {
      return "";
    }
  })


  return (
    <>
      {/* <div>결과 처리중...</div> */}
      {toast && (
        <ToastPopup
          setToast={setToast}
          position={"center"}
          message={toastMessage}
        />
      )}
    </>
  );
};

export default NiceRedirectPage;
